/**
 * This module should be the one we keep using for speedcurve events
 *
 * How to use it: dev should add four data attributes to the element it wants to track:
 *
 * On demand tracker
 * const myEvent = {
 *      eventType: "SpeedcurveEvent",
 *      handler: 'markStart|markEnd',
 *  }
 */
(function sitespeedTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};

  const previousModule = global.NewHomeSource.Analytics.SitespeedTracker;

  function markStart({ name }) {
    window.LUX.mark(name);
  }

  function markEnd({ measureName, markNameStart, markNameEnd }) {
    window.LUX.mark(markNameEnd);
    window.LUX.measure(measureName, markNameStart, markNameEnd);
  }

  const configurations = {
    markStart,
    markEnd,
  };

  /**
   * @constructs NewHomeSource.Analytics.SitespeedTracker
   */
  function SitespeedTracker(globalValues) {
    configurations.globalValues = globalValues;
  }

  SitespeedTracker.onDemandTracker = function () {
    if (!window.LUX) {
      return false;
    }

    const handler = configurations[this.handler];

    if (handler) {
      handler(this);
    }

    return true;
  };

  SitespeedTracker.onDemandTrackerValidator = function (data) {
    return data && data.eventType === 'SitespeedEvent';
  };

  /**
   * @public
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  SitespeedTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.SitespeedTracker = previousModule;
    return SitespeedTracker;
  };

  global.NewHomeSource.Analytics.SitespeedTracker = SitespeedTracker;

  return SitespeedTracker;
}(window));
